import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { PhHourglassMedium } from 'ember-phosphor-icons';
import HeroStat from 'tio-employee/components/dashboard-kit/hero-stat';
import type { ProgramPulse } from 'tio-employee/utils/partner-dashboard/sources/ta-analytics';
import type { WidgetComponentSignature } from 'tio-employee/utils/partner-dashboard/registry';

/** Hero tile: applications company-wide waiting on any reviewer. */
const InReviewWidget: TOC<WidgetComponentSignature<ProgramPulse>> = <template>
  <HeroStat
    @emphasis="metric"
    @label={{t "partner_dashboard.pulse.in_review"}}
    @value={{@data.inReview}}
    @context={{t "partner_dashboard.pulse.in_review_context"}}
    @contextIcon={{PhHourglassMedium}}
    data-test-partner-dashboard-in-review
  />
</template>;

export default InReviewWidget;
